import { useKitchensink } from './context'
import { ingestBaseUrl, tenantApiBaseUrl } from './env'
import { theme } from './theme'

export const Checklist = () => {
  const { variant, env, tenantSubdomain, tenantId } = useKitchensink()
  const ingest = ingestBaseUrl(env)
  const apiBase = tenantApiBaseUrl(env, tenantSubdomain || '<tenantSubdomain>')

  const items = [
    {
      label: 'Page view fired',
      description: 'A request is sent to',
      url: `${ingest}/api/s/page`,
      note: variant === 'spa' ? 'on every route navigation' : 'on every page load',
    },
    {
      label: 'Deanonymization tracked',
      description: 'A request is sent to',
      url: `${ingest}/api/s/track`,
      note: 'with a deanonymization event containing provider data',
    },
    {
      label: 'Identity posted',
      description: 'A request is sent to',
      url: `${apiBase}/api/web-data/v1/guest-external/tenant/${tenantId || '<tenantId>'}/person-deanonymized-identity`,
      note: 'with the deanonymized identity payload',
    },
  ]

  return (
    <div
      style={{
        backgroundColor: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: '10px',
        padding: '20px 24px',
      }}
    >
      <p
        style={{
          fontSize: '11px',
          fontWeight: 700,
          color: theme.textMuted,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          margin: '0 0 16px',
        }}
      >
        Network checklist
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {items.map(item => (
          <div
            key={item.label}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
            }}
          >
            <span
              style={{
                flexShrink: 0,
                marginTop: '2px',
                width: '16px',
                height: '16px',
                border: `1.5px solid ${theme.border}`,
                borderRadius: '4px',
                display: 'inline-block',
              }}
            />
            <div>
              <span
                style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: theme.text,
                  display: 'block',
                  marginBottom: '3px',
                }}
              >
                {item.label}
              </span>
              <span style={{ fontSize: '12px', color: theme.textMuted }}>
                {item.description}{' '}
                <code
                  style={{
                    fontFamily: 'ui-monospace, monospace',
                    fontSize: '11px',
                    color: theme.accent,
                    backgroundColor: theme.accentSubtle,
                    padding: '1px 5px',
                    borderRadius: '3px',
                    wordBreak: 'break-all',
                  }}
                >
                  {item.url}
                </code>{' '}
                {item.note}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
